import React from "react";
import { getShimmerClass } from "utils/constants/ui";
import { IMAGE_DIMENSIONS } from "./";

const CheckoutPreviewLoader = ({ withShimmer }) => {
  const shimmerClass = getShimmerClass(withShimmer);
  return (
    <div className="w-100">
      <div className="w-100">
        <div className={`${shimmerClass} h3 w-30`} />
        <div className="pt2">
          <div className={`${shimmerClass} h2 w-10`} />
        </div>
      </div>
      <div className="w-100 bb hairline-1 pb3">
        {new Array(3).fill("").map((_, nodeIx) => (
          <div key={nodeIx} className="w-100 flex flex-row pt3 items-center">
            <div className={shimmerClass} style={IMAGE_DIMENSIONS} />
            <div className="w-100 flex flex-column pl2">
              <div className="w-100 flex flex-row justify-between pb2">
                <div
                  style={{ height: 24 }}
                  className={`${shimmerClass} w-${3 + nodeIx}0`}
                />
                <div
                  style={{ height: 24 }}
                  className={`${shimmerClass} w-10`}
                />
              </div>
              <div className="w-100 flex flex-row justify-between">
                <div
                  style={{ height: 16 }}
                  className={`${shimmerClass} w-10`}
                />
                <div
                  style={{ height: 16 }}
                  className={`${shimmerClass} w-10`}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="w-100 flex flex-column">
        <div className="w-100 flex flex-row justify-between pb2">
          <div className="bg-white" style={IMAGE_DIMENSIONS} />
          <div className="w-100 flex flex-column pl2 pt3">
            <div className="w-100 flex flex-row justify-between">
              <div style={{ height: 24 }} className={`${shimmerClass} w-30`} />
              <div style={{ height: 24 }} className={`${shimmerClass} w-10`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CheckoutPreviewLoader;
